import { render, staticRenderFns } from "./RowBlockPaymentSystemCommissionPortmone.vue?vue&type=template&id=73f50851&"
import script from "./RowBlockPaymentSystemCommissionPortmone.vue?vue&type=script&lang=js&"
export * from "./RowBlockPaymentSystemCommissionPortmone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports